import axios from "axios"
import accessToken from "./jwt-token-access/accessToken"

//pass new generated access token here
const token = accessToken

//apply base url for axios
//export const API_URL = process.env.API_URL;
//export const API_URL = "http://localhost:8181/api"
//export const API_URL = "https://kattamintelligence.com/kattami/api"

export const API_URL = "https://www.kattam.ai/kattami/api"

const FAKE_API_URL = ""

const axiosApi = axios.create({
  baseURL: API_URL,
})

// axiosApi.defaults.headers.common["Authorization"] = token

axiosApi.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
)

//The interceptor did not take effect when I refreshed the page
//https://github.com/axios/axios/issues/1716
export function setTokenToHeader() {
  if (sessionStorage.getItem("authUser")) {
    const obj = JSON.parse(sessionStorage.getItem("authUser"))
    axiosApi.defaults.headers.common["Authorization"] = "Bearer " + obj.token
  } else {
    delete axiosApi.defaults.headers.common["Authorization"];
  }
}

export async function get(url, config = {}) {
  setTokenToHeader()
  return await axiosApi.get(url, config)
    .then(response => response.data)
}

export async function post(url, data, config = {}) {
  setTokenToHeader()
  return axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
}

export async function put(url, data, config = {}) {
  setTokenToHeader()
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del(url, config = {}) {
  setTokenToHeader()
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}

export async function postFile(url, data, config = {}) {
  setTokenToHeader()
  const formData = new FormData();
  formData.append('report', data)
  config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }
  return axiosApi
    .post(url, formData, { ...config })
    .then(response => response.data)
}

export async function getPDF(url, config = {}) {
  setTokenToHeader()
  return await axiosApi.get(url, config)
    .then(response => response)
}


